import {IOnDestroy, IOnInit, IRootElementService, IScope} from "angular";
import {DashboardPortfolioSummaryModel} from "./DashboardPortfolioSummaryModel";
import {ReplaySubject} from "rxjs";
import {MarginQuizService} from "../../../../quiz/margin/service/MarginQuizService";
import {CurrentUserService} from "../../../../services/user/CurrentUserService";
import {PortfolioSummary} from "../../../../portfolio/models/Portfolio";
import {ClientDashboardModel} from "../../models/ClientDashboardModel";
import {AccountStore} from "../../../../account/store/AccountStore";
import {PortfolioService} from "../../../../portfolio/service/PortfolioService";
import {isNotNull} from "../../../../js/util/UtilFunctions";

export class DashboardPortfolioSummaryComponentController implements IOnInit, IOnDestroy {
    public model: ClientDashboardModel;
    public currentPortfolio: DashboardPortfolioSummaryModel;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(protected readonly $scope: IScope,
                       protected readonly $element: IRootElementService,
                       protected readonly accountStore: AccountStore,
                       protected readonly portfolioService: PortfolioService,
                       protected readonly marginQuizService: MarginQuizService,
                       protected readonly currentUserService: CurrentUserService) {
    }

    public $onInit(): void {
        this.watchPortfolioSelection();
    }

    private watchPortfolioSelection() {
        this.accountStore
            .current
            .takeUntil(this.destroyed$)
            .filter(isNotNull)
            .map((account) => account.id)
            .flatMap((id) => this.portfolioService.summary(id))
            .filter((o) => o.isPresent())
            .map((o) => o.get())
            .subscribe((summary) => this.currentPortfolioChanged(summary));
    }

    private currentPortfolioChanged(portfolioSummary: PortfolioSummary | null) {
        this.currentPortfolio = DashboardPortfolioSummaryModel.build(portfolioSummary);
        this.$scope.$applyAsync();
    }

    public async takeOptionsQuiz() {
        await this.marginQuizService.open();
        this.$scope.$applyAsync();
    }

    public get showQuizMessage(): boolean {
        return this.currentUserService.isClient() && !this.currentUserService.hasPassedMarginQuiz();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
